import { Pressable, Linking } from 'react-native';
import { Text } from '@betty/moonlight';
import { useCallback } from 'react';
import { useTranslation } from '@betty/i18n';
import { StackNavigationProp, useNavigation } from '@betty/navigation';
import { FooterLink as FooterLinkType } from '../FooterLinks/FooterLinks.constants';
import { logError } from '@betty/toolkit/logging';

function FooterLink({ labelKey, miscPath, link, navigateTo }: FooterLinkType) {
  const { t } = useTranslation('account');
  const navigation =
    useNavigation<StackNavigationProp<AppNavigatorParamsList>>();

  const handlePress = useCallback(() => {
    if (miscPath) {
      navigation.navigate('MiscScreen', { path: miscPath });
    } else if (link) {
      Linking.openURL(link).catch((err) =>
        logError('Failed to open URL:', err),
      );
    } else if (navigateTo) {
      navigation.navigate(navigateTo);
    }
  }, [miscPath, link, navigateTo, navigation]);

  return (
    <Pressable onPress={handlePress}>
      <Text
        variant="body-m-semi"
        color="darkSurfacePrimary"
        paddingBottom="space-800"
      >
        {t(labelKey)}
      </Text>
    </Pressable>
  );
}

export default FooterLink;
